import { useCallback } from "react";
import { Link } from "react-router-dom";
import { LoadingState } from "../components/LoadingState";
import { ArchiveIndex } from "../components/ArchiveIndex";
import { FeaturedReportSurface } from "../components/FeaturedReportSurface";
import { HomeProSection } from "../components/HomeProSection";
import { RecentIntelligence } from "../components/RecentIntelligence";
import { ReportVisualStrip } from "../components/ReportVisualStrip";
import { UnavailableState } from "../components/UnavailableState";
import { useFtmDataService } from "../context/FtmDataServiceContext";
import { useFtmResource } from "../hooks/useFtmResource";

export function DiscoverPage() {
  const service = useFtmDataService();
  const loadDiscover = useCallback(() => service.loadDiscover(), [service]);
  const { data, loading, error } = useFtmResource(loadDiscover);

  if (loading) return <LoadingState />;
  if (error || !data) return <UnavailableState title="Discover could not load." message={error ?? "The current public snapshot is unavailable."} />;

  const todayReports = data.currentReports.slice(0, 5);
  const featuredReport = todayReports.find((report) => report.featured && report.accessTier === "free") ?? todayReports.find((report) => report.featured) ?? todayReports[0] ?? null;

  return <main id="main-content">
    {featuredReport ? <FeaturedReportSurface report={featuredReport} /> : <section className="site-shell section-block"><EmptyReports /></section>}

    <section className="site-shell section-block home-today" aria-labelledby="today-ftm-heading"><div className="section-heading-row"><div><p className="eyebrow">CURRENT REPORTS</p><h2 className="section-title" id="today-ftm-heading">Today&apos;s FTM</h2><p className="home-section-subtitle">FTM publishes selectively.</p></div><span className="home-section-note">{todayReports.length ? `${todayReports.length} current ${todayReports.length === 1 ? "Report" : "Reports"}` : "No current Reports"}</span></div>{todayReports.length ? <div className="home-report-strips">{todayReports.map((report) => <ReportVisualStrip key={report.reportId} report={report} isFeatured={report.reportId === featuredReport?.reportId && report.accessTier === "free"} />)}</div> : <EmptyReports />}</section>

    <RecentIntelligence reports={todayReports} archive={data.archive} entries={data.recentIntelligence ?? []} />

    <section className="site-shell section-block home-archive-preview" aria-labelledby="archive-preview-heading"><div className="section-heading-row"><div><p className="eyebrow">ARCHIVE INDEX</p><h2 className="section-title" id="archive-preview-heading">A record of the view.</h2></div><Link className="text-link" to="/archive">Open Archive <span aria-hidden="true">→</span></Link></div><ArchiveIndex entries={data.archive.slice(0, 3)} preview /></section>

    <HomeProSection />
  </main>;
}

function EmptyReports() {
  return <div className="empty-state"><p className="eyebrow">NO CURRENT REPORTS</p><p className="empty-state-title">The public snapshot is quiet.</p><p className="empty-state-copy">FTM does not invent a Featured Report when the current data provider has no reviewed publication.</p></div>;
}
